// Определение окружения по хосту
const PROD_HOSTS = new Set([
  "cue.ktsf.ru", // Основной прод
  "kassa-frontend-react.vercel.app", // Техдомен прод-деплоя
]);

// Флаги окружения
export const isProdHost = PROD_HOSTS.has(window.location.hostname);

// Временный флаг для превью-домена
export const isPreviewHost =
  /\.vercel\.app$/.test(window.location.hostname) && !isProdHost;
